<stages-dialog2 #dialog [dialogAriaLabel]="'setState' | translate">
	<stages-dialog-header />

	@if (credentialsValid) {
		@if (fileStateDataAndInfo$ | async; as fileStateDataAndInfo) {
			<span class="h1" translate="setState"></span>
			<form [formGroup]="form" class="content" novalidate #formElement>
				<div class="form">
					<stages-attribute-edit
						[attributeTypes]="fileStateDataAndInfo.metadata.attributeTypes"
						[attributes]="fileStateDataAndInfo.data.attributes"
						[form]="form"
						(change)="hasFormChanges(fileStateDataAndInfo)"
					>
					</stages-attribute-edit>
					@if (isNotifyUsersAllowed(fileStateDataAndInfo)) {
						<div class="input-container">
							<label for="notify" class="input-label" translate="files.notification.notify.users"></label>
							<div>
								<input
									type="checkbox"
									hidden="hidden"
									id="notify"
									name="notify"
									[checked]="notifyUsers"
									(change)="showNotificationOptions()"
								/>
								<label for="notify" class="switch"></label>
							</div>
						</div>
					}
				</div>
				<div class="spacing"></div>
				@if (notifyUsers) {
					<stages-files-notifications
						(notificationInformation)="setNotificationInformation($event)"
						[isNewFile]="false"
					>
					</stages-files-notifications>
				}
			</form>
			<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons">
				@if (form) {
					<button
						class="button sm ok"
						ngClass="action.buttonClass"
						translate="setState"
						(click)="submit(fileStateDataAndInfo)"
					></button>
				}
			</stages-popup-footer>
		} @else {
			@if (loadingError$ | async; as error) {
				<span class="h1" translate="error.title"></span>
			}
			<stages-popup-content>
				<stages-loading-error-embeddable [credentialsValid]="credentialsValid" [loadingError$]="loadingError$" />
			</stages-popup-content>
			<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons" />
		}
	} @else {
		@if (!credentialsValid && !oAuthUrl) {
			<stages-files-auth-embeddable #auth [cmsTypeMessageKey]="cmsTypeMessageKey!" />
		}
		@if (!credentialsValid && oAuthUrl) {
			<stages-files-oauth-embeddable-confirm
				[cmsTypeMessageKey]="cmsTypeMessageKey!"
				[authUrl]="oAuthUrl"
				[closeCallback]="close"
			/>
		}
	}
</stages-dialog2>

